import { supabase } from '../utils/supabase';

export interface CreateUserData {
  id: string;
  email: string;
  name: string;
}

export interface UserServiceResponse {
  success: boolean;
  message: string;
  error?: Error;
}

export class UserService {
  /**
   * Update user name in the public.users table
   */
  static async updateUserName(userId: string, name: string): Promise<UserServiceResponse> {
    if (!userId) {
      return {
        success: false,
        message: 'User ID is required',
        error: new Error('User ID is required')
      };
    }

    if (!name?.trim()) {
      return {
        success: false,
        message: 'User name is required',
        error: new Error('User name is required')
      };
    }

    try {
      const { error } = await supabase
        .from('users')
        .update({ name: name.trim() })
        .eq('id', userId);

      if (error) {
        throw new Error(error.message);
      }

      return {
        success: true,
        message: 'Nome do usuário atualizado com sucesso'
      };
    } catch (error) {
      return {
        success: false,
        message: (error as Error).message,
        error: error as Error
      };
    }
  }

  /**
   * Create a new user record in the public.users table
   */
  static async createUser(userData: CreateUserData): Promise<UserServiceResponse> {
    if (!userData.id) {
      return {
        success: false,
        message: 'User ID is required',
        error: new Error('User ID is required')
      };
    }

    if (!userData.email?.trim()) {
      return {
        success: false,
        message: 'User email is required',
        error: new Error('User email is required')
      };
    }

    if (!userData.name?.trim()) {
      return {
        success: false,
        message: 'User name is required',
        error: new Error('User name is required')
      };
    }

    try {
      const { error } = await supabase
        .from('users')
        .insert({
          id: userData.id,
          email: userData.email.trim(),
          name: userData.name.trim()
        });

      if (error) {
        throw new Error(error.message);
      }

      return {
        success: true,
        message: 'Usuário criado com sucesso'
      };
    } catch (error) {
      return {
        success: false,
        message: (error as Error).message,
        error: error as Error
      };
    }
  }
}